export default __webpack_public_path__ + "assets/audios/button-click.mp3";